angular.module('env.data.rest.model.fieldDefinition', [])

    .constant('FieldValidator',
        /**
         * Representation model field validator
         * @param {function|Array} validate validate function or array of function
         * @param {string} [message] validation message
         * @param {Array} [messageArgs] message arguments (for insertion into %s in message string)
         * @constructor
         */
        function FieldValidator(validate, message, messageArgs) {
            var _this = this;
            if (_.isFunction(validate)) {
                _this.validators = [validate];
            } else if (_.isArray(validate) && _.every(validate, _.isFunction)) {
                _this.validators = validate;
            } else {
                throw new Error("Illegal argument exception");
            }
            _this.message = message;
            _this.messageArgs = messageArgs;
            _this.getFormattedMessage = function (translateFunc) {
                if (!_this.message) {
                    return;
                }
                var msg = translateFunc ? translateFunc(_this.message) : _this.message;
                if (_this.messageArgs && _this.messageArgs.length > 0) {
                    return _.str.sprintf.apply(this, [msg].concat(_this.messageArgs));
                }
                return msg;
            };
        })

    // enum of available field types
    .constant('RepresentationModelFieldTypes', {
        DEFAULT: 'dynamic',
        DYNAMIC: 'dynamic',
        OBJECT: 'OBJECT',
        FLOAT: 'number',
        INTEGER: 'integer',
        STRING: 'string',
        BOOLEAN: 'boolean',
        DATE: 'date',
        ARRAY: 'array',
        MODEL: 'model'
    })

    .factory('FieldDefinition', function (RepresentationModelFieldTypes, FieldValidator, gettextCatalog) {


            /**
             * Definition of field
             * @param {string} fieldName - name of the field
             * @param {*} fieldConfig - field definition config
             * @constructor
             */
            function FieldDefinition(fieldName, fieldConfig) {

                this._fieldName = fieldName;
                this._fieldConfig = fieldConfig;

                /**
                 * Client-side name of the field
                 * @type {string}
                 */
                this.name = this._fieldConfig.name || this._fieldName;

                /**
                 * Server-side name of the field
                 * @type {string}
                 */
                this.serverName = this._fieldConfig.serverName || this.name;

                /**
                 * Field type
                 * @see {@link RepresentationModelFieldTypes} for further information.
                 * @type {string|RepresentationModelFieldTypes.DEFAULT}
                 */
                this.type = this._fieldConfig.type || RepresentationModelFieldTypes.DEFAULT;

                /**
                 * Default value
                 */
                this.defaultValue = this._fieldConfig.defaultValue;

                /**
                 * Is sub resource
                 * @type {boolean}
                 */
                this.subResource = !!this._fieldConfig.subResource;

                this.get = (!this._fieldConfig.get || !_.isFunction(this._fieldConfig.get))
                    ? _.noop
                    : this._fieldConfig.get.bind(this);
                this.save = (!this._fieldConfig.save || !_.isFunction(this._fieldConfig.save))
                    ? null
                    : this._fieldConfig.save.bind(this);

                this.encode = _.isFunction(this._fieldConfig.encode)
                    ? this._fieldConfig.encode.bind(this)
                    : null;
                this.decode = _.isFunction(this._fieldConfig.decode)
                    ? this._fieldConfig.decode.bind(this)
                    : null;

                /**
                 * Validators
                 */
                this._validators = [];

                this._initValidators(this._fieldConfig.validators);
            }

            FieldDefinition.prototype._initValidators = function (parts) {
                var _this = this;
                if (parts) {
                    if (_.isArray(parts)) {
                        parts = _.flatten(parts);
                        for (var i = 0; i < parts.length; i++) {
                            if (_.isFunction(parts[i])) {
                                if (parts[i + 1] && _.isString(parts[i + 1])) {
                                    var msgArgs = [];
                                    for (var j = i + 2; j < parts.length && _.isString(parts[j]); j++) {
                                        msgArgs.push(parts[j]);
                                    }
                                    _this._validators.push(new FieldValidator(parts[i], parts[i + 1], msgArgs));
                                    i = j - 1;
                                } else {
                                    _this._validators.push(new FieldValidator(parts[i]));
                                }
                            } else if (parts instanceof FieldValidator) {
                                _this._validators.push(_.clone(parts));
                            }
                        }
                    } else if (parts instanceof FieldValidator) {
                        _this._validators.push(parts);
                    } else if (_.isFunction(parts)) {
                        _this._validators.push(new FieldValidator(parts));
                    }
                }
            }

            /**
             * Validate field
             * @param {Object} value value to validate
             * @param {RepresentationModel} model model
             * @returns {Array} array of validation errors
             */
            FieldDefinition.prototype.validate = function (value, model) {
                var _this = this;
                var errors = this._validateInternal(value);
                if (errors.length > 0) { // to prevent type errors in custom validators
                    return errors;
                }

                var wasUnmarkedError = false;
                var wasErrorLocal = false;
                _.forEach(_this._validators, function (validator) {
                    wasErrorLocal = false;
                    _.forEach(validator.validators, function (vFunc) {
                        var result = vFunc(value, _this, model);
                        if (result != true) {
                            if (_.isString(result)) {
                                errors.push(result);
                            } else if (_.isArray(result) && _.every(result, _.isString)) {
                                errors.concat(result);
                            } else {
                                wasErrorLocal = true;
                            }
                        }
                    });
                    var msg = validator.getFormattedMessage(gettextCatalog);
                    if (msg) {
                        errors.push(msg);
                        wasErrorLocal = false;
                    } else if (wasErrorLocal) {
                        wasUnmarkedError = true;
                    }
                });

                if (wasUnmarkedError) {
                    errors.push(gettextCatalog.getString("Field is not valid")); // default alert
                }

                return errors;
            }

            /**
             * Validate field internal
             * @param {Object} value - value to validate
             * @returns {Array} array of validation errors
             */
            FieldDefinition.prototype._validateInternal = function (value) {
                var errors = [];
                if (_.isNull(value) || _.isUndefined()) {
                    return errors;
                }

                if (this.type == RepresentationModelFieldTypes.FLOAT) {
                    if (!_.isNumber(value) || !_.isFinite(value)) {
                        errors.push(gettextCatalog.getString("Value must be number"));
                    }
                } else if (this.type == RepresentationModelFieldTypes.INTEGER) {
                    if (!_.isNumber(value) || !_.isFinite(value) || (!_.isNaN(value) && (value % 1 === 0))) {
                        errors.push(gettextCatalog.getString("Value must be integer number"));
                    }
                } else if (this.type == RepresentationModelFieldTypes.STRING) {
                    if (!_.isString(value)) {
                        errors.push(gettextCatalog.getString("Value must be string"));
                    }
                } else if (this.type == RepresentationModelFieldTypes.BOOLEAN) {
                    if (!_.isBoolean(value)) {
                        errors.push(gettextCatalog.getString("Value must be true or false"));
                    }
                } else if (this.type == RepresentationModelFieldTypes.DATE) {
                    if (!_.isDate(value)) {
                        errors.push(gettextCatalog.getString("Value must be Date"));
                    }
                }

                return errors;
            }

            return (FieldDefinition);
        }
    )

;
